import React from 'react';

import Button from '../../../components/ui/Button';

const OrdersTableMobile = ({ orders, onViewDetails, onUpdateStatus, selectedOrders, onSelectOrder }) => {
  const getStatusColor = (status) => {
    const colors = {
      '주문 접수': 'bg-blue-100 text-blue-800',
      '픽업 예정': 'bg-yellow-100 text-yellow-800',
      '세탁 중': 'bg-purple-100 text-purple-800',
      '배송 예정': 'bg-orange-100 text-orange-800',
      '완료': 'bg-green-100 text-green-800'
    };
    return colors?.[status] || 'bg-gray-100 text-gray-800';
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return `${date?.getFullYear()}.${String(date?.getMonth() + 1)?.padStart(2, '0')}.${String(date?.getDate())?.padStart(2, '0')}`;
  };

  const formatPrice = (price) => {
    return `${price?.toLocaleString('ko-KR')}원`;
  };

  return (
    <div className="space-y-4">
      {orders?.map((order) => (
        <div key={order?.id} className="rounded-lg border border-border bg-card p-4 shadow-sm">
          <div className="mb-3 flex items-start justify-between">
            <div className="flex items-start space-x-3">
              <input
                type="checkbox"
                checked={selectedOrders?.includes(order?.id)}
                onChange={() => onSelectOrder(order?.id)}
                className="mt-1 h-4 w-4 rounded border-border text-accent focus:ring-2 focus:ring-accent"
              />
              <div>
                <p className="text-sm font-semibold text-foreground">{order?.orderNumber}</p>
                <p className="text-xs text-muted-foreground">{formatDate(order?.orderDate)}</p>
              </div>
            </div>
            <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getStatusColor(order?.status)}`}>
              {order?.status}
            </span>
          </div>

          <div className="mb-3 space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">고객명</span>
              <span className="text-sm font-medium text-foreground">{order?.customerName}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">연락처</span>
              <span className="text-sm text-foreground">{order?.phone}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">주소</span>
              <span className="text-sm text-foreground text-right">{order?.address}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">항목 수</span>
              <span className="text-sm text-foreground">{order?.itemsCount}개</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">금액</span>
              <span className="text-sm font-semibold text-foreground">{formatPrice(order?.totalAmount)}</span>
            </div>
          </div>

          <div className="flex space-x-2 border-t border-border pt-3">
            <Button
              variant="outline"
              size="sm"
              iconName="Eye"
              iconPosition="left"
              onClick={() => onViewDetails(order)}
              fullWidth
            >
              상세보기
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Edit"
              iconPosition="left"
              onClick={() => onUpdateStatus(order)}
              fullWidth
            >
              상태변경
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrdersTableMobile;